@if (!customerValidated) {
  <app-quick-launch-content
    (launch)="setValidation($event)"
    [validationModel]="validationModel">
  </app-quick-launch-content>
}

@if (customerValidated) {
  <app-test-launcher
    [journeyId]="selectedJourney"
    [ccid]="ccid"
    [validation]="validationModel"
    (validationFailed)="onValidationFailed($event)">
  </app-test-launcher>
}

<message-dialog [showCancel]="false"></message-dialog>
